export var LinkTermTypesEnum;
(function (LinkTermTypesEnum) {
    LinkTermTypesEnum["SHORT_LINK"] = "shortLink";
})(LinkTermTypesEnum || (LinkTermTypesEnum = {}));
